export function getSignupEmailQueryParam(search) {
    if (!search) {
        return null;
    }
    const params = new URLSearchParams(search);
    const email = params.get('email');
    return email || null;
}
